import React, { Component } from "react";
import $ from "jquery";

import truecallerLogo from "../images/sample-truecaller.jpeg";
import fiverrLogo from "../images/fiver.png";
import cheggLogo from "../images/chegg.png";
import chitkaraUniversityLogo from "../images/logo_chitkara.png";
import intershalaLogo from "../images/isp_logo.png";
import thinkifyLogo from "../images/thinkify.png";
import audotaskLogo from "../images/audotask-logo.png";
import jupiterLogo from "../images/jupiter.png";

export class SkillsComponent extends Component {
  componentDidMount() {
    $(".bar").each(function() {
      $(this)
        .find(".bar-inner")
        .animate(
          {
            width: $(this).attr("data-width"),
          },
          2000
        );
    });
  }
  render() {
    return (
      <div className="skills-background" id="experience">
        <div className="container">
          <div className="row">
            <h1 id="skills">Experience & Education</h1>
          </div>
          <div className="row  skills-bar">
            <div className="col-md-6">
              <div className="bar-1">
                <div className="title">Frontend Development</div>
                <span>
                  {" "}
                  <small className="skillset-name">
                    {" "}
                    HTML, CSS, Javascript, ES6, React JS, Redux, Vue JS, React
                    Native
                  </small>
                </span>
                <div className="bar" data-width="90%">
                  <div className="bar-inner"> </div>
                </div>
              </div>
              <div className="bar-1">
                <div className="title">Backend Development</div>
                <span>
                  {" "}
                  <small className="skillset-name">
                    {" "}
                    Express JS, Django, Ruby on Rails
                  </small>
                </span>
                <div className="bar" data-width="60%">
                  <div className="bar-inner"></div>
                </div>
              </div>
              <div className="bar-1">
                <div className="title">C++ (DS/ Algo)</div>
                <div className="bar" data-width="55%">
                  <div className="bar-inner"></div>
                </div>
              </div>
              <div className="bar-1">
                <div className="title">Core Java</div>
                <div className="bar" data-width="50%">
                  <div className="bar-inner"></div>
                </div>
              </div>
              <div className="bar-1">
                <div className="title">Databases(SQL/NOSQL)</div>
                <span>
                  {" "}
                  <small className="skillset-name">
                    {" "}
                    MYSQL, Postgres, MongoDB
                  </small>
                </span>
                <div className="bar" data-width="45%">
                  <div className="bar-inner"></div>
                </div>
              </div>

              <div className="bar-1">
                <div className="title">Miscellaneous</div>
                <span>
                  {" "}
                  <small className="skillset-name">
                    {" "}
                    Git, Chrome Extensions Development, Actions on Google
                  </small>
                </span>
                <div className="bar" data-width="70%">
                  <div className="bar-inner"></div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="container ">
                <div className="phone" style={{ zIndex: "0" }}>
                  <div className="notch"> </div>
                  <div className="screen">
                    <div
                      id="carouselExampleInterval"
                      className="carousel slide "
                      data-ride="carousel"
                    >
                      <div className="carousel-inner">
                        <div
                          className="carousel-item active "
                          data-interval="5000"
                        >
                          <div
                            className="card w-100 border border-light bg-light"
                            style={{
                              cursor: "default",
                              boxShadow: "20px grey",
                            }}
                          >
                            <img
                              src={jupiterLogo}
                              className="card-img-top"
                              height="200"
                              alt="truecaller"
                            />

                            <div className="card-body">
                              <b className="card-title ">SDE 1</b>
                              <br />
                              <small className="">June 2022 - April 2023</small>
                              <p className="card-text">
                                I had worked in the payments team on Bill
                                Payments, UPI mandates, On-Demand Salary and
                                several other crucial revenue generating
                                products.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item " data-interval="5000">
                          <div
                            className="card w-100 bg-light border border-light"
                            style={{ cursor: "default" }}
                          >
                            <img
                              src={thinkifyLogo}
                              className="card-img-top"
                              height="200"
                              alt="chegg"
                            />
                            <div className="card-body">
                              <b className="card-title">Software Engineer</b>
                              <br />
                              <small>April 2021 - June 2022</small>
                              <p className="card-text">
                                I have worked with Swiggy team as UI Engineer on
                                the Experimentation Platform.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item" data-interval="5000">
                          <div
                            className="card w-100 border border-light bg-light"
                            style={{
                              cursor: "default",
                              boxShadow: "20px grey",
                            }}
                          >
                            <img
                              src={truecallerLogo}
                              className="card-img-top"
                              height="200"
                              alt="truecaller"
                            />

                            <div className="card-body">
                              <b className="card-title ">
                                Web Developer Intern
                              </b>
                              <br />
                              <small className="">May 2019 - Sept 2020</small>
                              <p className="card-text">
                                I have worked for Truecaller for Developers
                                where I worked on Developer portal of truecaller
                                alongside bunch of other cool projects.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="carousel-item " data-interval="5000">
                          <div
                            className="card w-100 bg-light border border-light"
                            style={{ cursor: "default" }}
                          >
                            <img
                              src={audotaskLogo}
                              className="card-img-top"
                              height="200"
                              alt="chegg"
                            />
                            <div className="card-body">
                              <b className="card-title">Founder - Audotask</b>
                              <br />
                              <small>November 2020 - Present</small>
                              <p className="card-text">
                                I have been working on building and growing the
                                Audotask from just an idea in my mind to a
                                real-life application of it.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item " data-interval="5000">
                          <div
                            className="card w-100 bg-light border border-light"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              window.open(
                                "https://www.fiverr.com/hardik_chugh?public_mode=true",
                                "_blank"
                              )
                            }
                          >
                            <img
                              src={fiverrLogo}
                              className="card-img-top"
                              height="200"
                              alt="fiverr"
                            />
                            <div className="card-body">
                              <b className="card-title ">
                                Professional Freelancer
                              </b>
                              <br />
                              <small>May 2019 - Sept 2019</small>
                              <p className="card-text">
                                I provided my services to various clients
                                regarding Git issues and Website Development on
                                Fiverr.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item " data-interval="5000">
                          <div
                            className="card w-100 bg-light border border-light"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              window.open(
                                "https://www.chegg.com/tutors/online-tutors/Hardik-C-8705985/",
                                "_blank"
                              )
                            }
                          >
                            <img
                              src={cheggLogo}
                              className="card-img-top"
                              height="200"
                              alt="chegg"
                            />
                            <div className="card-body">
                              <b className="card-title">Instructor</b>
                              <br />
                              <small>Dec 2018 - Mar 2019</small>
                              <p className="card-text">
                                At chegg Tutors, I helped various students
                                around the globe with my knowledge of
                                programming.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item " data-interval="5000">
                          <div
                            className="card w-100 bg-light border border-light"
                            style={{ cursor: "default" }}
                          >
                            <img
                              src={intershalaLogo}
                              className="card-img-top"
                              height="200"
                              alt="chegg"
                            />
                            <div className="card-body">
                              <b className="card-title">
                                Internshala Student Partner 9.0
                              </b>
                              <br />
                              <small>March 2018 - Jun 2018</small>
                              <p className="card-text">
                                I was part of ISP 9.0 where I scored 16th
                                position among 12000 students approximately.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="carousel-item " data-interval="5000">
                          <div
                            className="card w-100 bg-light border border-light"
                            style={{ cursor: "default" }}
                          >
                            <img
                              src={chitkaraUniversityLogo}
                              className="card-img-top"
                              height="200"
                              alt="b.tech"
                            />
                            <div className="card-body">
                              <b className="card-title">
                                B.E ( Computer Science )
                              </b>
                              <br />
                              <small>Batch 2016-2020</small>
                              <p className="card-text">
                                I have completed my B.E in Computer Science from
                                Chitkara University, Punjab with CGPA of 8.85
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <a
                        className="carousel-control-prev bg-dark carousel-icon h-25"
                        href="#carouselExampleInterval"
                        role="button"
                        data-slide="prev"
                      >
                        <span
                          className="carousel-control-prev-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="sr-only">Previous</span>
                      </a>
                      <a
                        className="carousel-control-next bg-dark carousel-icon h-25"
                        href="#carouselExampleInterval"
                        role="button"
                        data-slide="next"
                      >
                        <span
                          className="carousel-control-next-icon"
                          aria-hidden="true"
                        ></span>
                        <span className="sr-only">Next</span>
                      </a>
                    </div>

                    <div className="d-flex">
                      <div
                        className="button-8"
                        onClick={() => {
                          window.location =
                            "https://docs.google.com/document/d/1JEjjVuMPcZ1ielzZozyudlIDAnO11M8SyAGMA51SkBY/export?format=pdf";
                        }}
                      >
                        <div className="eff-8"></div>
                        <a href="https://docs.google.com/document/d/1JEjjVuMPcZ1ielzZozyudlIDAnO11M8SyAGMA51SkBY/export?format=pdf">
                          {" "}
                          Resume{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SkillsComponent;
